import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanDeactivate,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { SharedService } from '../sheared/sharedService.service';
import { map } from 'rxjs/operators';
import { sigUserModel } from 'src/app/Models/sigUserModel';
import { Usercredentiel } from 'src/app/Pages/login/login.page';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { authenticationService } from '../Authentication/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class authGuardService implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  constructor(private authenticateService:authenticationService,private router: Router) {
   
  }

  canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const url: string = state.url;
    return this.checkUserLogin(next, url);
  }
  canActivateChild(next: ActivatedRouteSnapshot,state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(next, state);
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {

    if (this.authenticateService.isAuthenticated(url)) 
        return true;

    this.router.navigateByUrl('/login',{replaceUrl:true});
    return false;
  }

  
}
